import client from "api/client";


const _client = client.route("/script");

const start = {
	get: () => _client.get("")
};

export default start;